__turbopack_context__.v({
  "allTerms": "glossaryTerms-module-scss-module__glFZ3G__allTerms",
  "termItems": "glossaryTerms-module-scss-module__glFZ3G__termItems",
  "title": "glossaryTerms-module-scss-module__glFZ3G__title",
  "titleWrapper": "glossaryTerms-module-scss-module__glFZ3G__titleWrapper",
});
